import { ResidenceFormNorlys } from '~src/components/ResidenceForm';
import { useDisplayContext } from '~src/context/DisplayContext';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';

export const ResidenceInformationNorlys = () => {
  const { isMobile } = useDisplayContext();
  const { residence, setResidence } = usePublicCalculatorContext();

  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: isMobile ? undefined : 'center' }}>
      <ResidenceFormNorlys
        {...{
          type: 'calculator',
          residence,
          onUpdate: output =>
            setResidence?.({
              ...residence,
              ...output,
            }),
        }}
      />
    </div>
  );
};
